"use client"

import { createContext, useContext, type ReactNode } from "react"

export interface DrawerDetailTheme {
    color: string
}

const defaultTheme: DrawerDetailTheme = {
    color: "#FFF",
}

const DrawerDetailThemeContext = createContext<DrawerDetailTheme>(defaultTheme)

export function useDrawerDetailTheme() {
    return useContext(DrawerDetailThemeContext)
}

interface DrawerDetailProviderProps {
    theme: Partial<DrawerDetailTheme>
    children: ReactNode
}

export function DrawerDetailProvider({ theme, children }: DrawerDetailProviderProps) {
    const merged: DrawerDetailTheme = { ...defaultTheme, ...theme }
    return (
        <DrawerDetailThemeContext.Provider value={merged}>
            {children}
        </DrawerDetailThemeContext.Provider>
    )
}
